import { Stack } from '@mui/material';

import clsx from 'clsx';

import ImageUploadButton from './ImageUploadButton';
import InsertFormulaButton from './InsertFormulaButton';
import TextFormattingButtons from './TextFormattingButtons';
import { ToolbarCustomizationProps,ToolbarProps } from './types';
import useToolbarVM from './vm';

export type { ToolbarProps, ToolbarCustomizationProps };

const Toolbar = ({
  className,
  classes,
  canFormatText = true,
  canInsertFormula = true,
  canUploadImage = true,
  children,
  i18n,
  renderCreateFormulaOverlay,
}: ToolbarProps) => {
  const { editorRef } = useToolbarVM();

  return (
    <Stack direction="row" alignItems="center" gap={2} p={2} className={clsx(className, classes?.root)}>
      {canFormatText && <TextFormattingButtons editorRef={editorRef} classes={classes} />}
      {canInsertFormula && (
        <InsertFormulaButton
          editorRef={editorRef}
          renderCreateFormulaOverlay={renderCreateFormulaOverlay}
          i18n={i18n}
          classes={classes}
        />
      )}
      {canUploadImage && <ImageUploadButton editorRef={editorRef} classes={classes} />}
      {children}
    </Stack>
  );
};

export default Toolbar;

export { default as TextFormattingButtons } from './TextFormattingButtons';
export { default as InsertFormulaButton } from './InsertFormulaButton';
export { default as ImageUploadButton } from './ImageUploadButton';
